import React from 'react';
import { useTranslation } from 'react-i18next';

export default function DebriefPanel({
  debrief,
  gamification,
  onPlayAgain,
  onNextModule,
  onBackToTracks,
}) {
  const { t } = useTranslation('session');
  const tc = (key) => t(key, { ns: 'common' });

  if (!debrief) return null;

  const accuracyPct = Math.round(debrief.accuracy * 100);
  const avgTime = Math.round(debrief.average_response_time_ms / 1000 * 10) / 10;

  return (
    <div className="debrief-panel">
      <h2>{t('session_complete')}</h2>

      <div className="debrief-stats">
        <div className="stat-card">
          <div className="stat-value">{debrief.correct_answers}/{debrief.total_questions}</div>
          <div className="stat-label">{t('correct_answers')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{accuracyPct}%</div>
          <div className="stat-label">{tc('accuracy')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{avgTime}s</div>
          <div className="stat-label">{t('avg_response_time')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{Math.round(debrief.overall_score * 100)}%</div>
          <div className="stat-label">{t('overall_score')}</div>
        </div>
      </div>

      {debrief.question_results?.length > 0 && (
        <div className="debrief-results">
          <h3>{t('feedback')}</h3>
          {debrief.question_results.map((r, i) => (
            <div key={i} className={`result-row ${r.is_correct ? 'correct' : 'incorrect'}`}>
              <div className="result-prompt">{r.prompt}</div>
              <div className="result-meta">
                <span className={r.is_correct ? 'badge-correct' : 'badge-incorrect'}>
                  {r.is_correct ? tc('correct') : tc('incorrect')}
                </span>
                <span className="result-time">{Math.round(r.response_time_ms / 1000 * 10) / 10}s</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {gamification && (
        <div className="debrief-gamification">
          <div className="debrief-stats">
            {gamification.xp_earned > 0 && (
              <div className="stat-card">
                <div className="stat-value">+{gamification.xp_earned}</div>
                <div className="stat-label">{t('xp_earned', 'XP Earned')}</div>
              </div>
            )}
            {gamification.profile && (
              <div className="stat-card">
                <div className="stat-value">Lv {gamification.profile.level}</div>
                <div className="stat-label">{gamification.profile.level_name || t('level', 'Level')}</div>
              </div>
            )}
            {gamification.level_up && (
              <div className="stat-card">
                <div className="stat-value" style={{ color: '#34d399' }}>{t('level_up', 'Level Up!')}</div>
                <div className="stat-label">Lv {gamification.new_level}</div>
              </div>
            )}
          </div>
          {gamification.new_badges?.length > 0 && (
            <div className="debrief-badges">
              <h4>{t('new_badges', 'New Badges')}</h4>
              <div className="badge-list">
                {gamification.new_badges.map((b, i) => (
                  <span key={i} className="debrief-badge">&#127942; {b.badge_id}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="debrief-actions">
        {onBackToTracks && (
          <button type="button" className="btn-text" onClick={onBackToTracks}>{t('back_to_tracks')}</button>
        )}
        <button className="btn-secondary" onClick={onPlayAgain}>{t('play_again')}</button>
        {onNextModule && (
          <button className="btn-primary" onClick={onNextModule}>{t('next_module')}</button>
        )}
      </div>
    </div>
  );
}
